import { makeStyles } from '../../../../../styles';
import { palette } from '../../../../electrons';
export const useStyles = makeStyles((theme) => ({
    root: Object.assign(Object.assign({}, theme.typography.body2), { borderBottom: `1px solid ${palette.divider}` }),
}));
//# sourceMappingURL=TableCell.styles.js.map